import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import { getStoredValue } from '../../_helpers/storagehelper.js';

function Content() {
	const menuList = getStoredValue("menu_list") || [];
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 849);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 849);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<AppSettings.Consumer>
			{({ appContentClass, appSidebarMinify }) => (
				<div
					className={'app-content ' + appContentClass}
					style={{
						marginLeft: isMobile
							? "0"
							: appSidebarMinify
								? "20px"
								: menuList?.length > 0
									? "220px"
									: ""
					}}
				>
					<Outlet />
				</div>
			)}
		</AppSettings.Consumer>
	);
}

export default Content;
